import React from 'react';
const LeadFromSlug = React.lazy(() => import('~/components/Leads/LeadFromSlug'));

const manageLeadTopicsRoute = {
  path: "leads/:slug/topics",
  element: <LeadFromSlug />
}

export default manageLeadTopicsRoute